import api from './api';
import type { User } from '../types';

export interface UpdateProfileRequest {
  age?: number | undefined;
  gender?: string | undefined;
  bio?: string | undefined;
  drugUsePreference?: string | undefined;
  socialPreference?: string | undefined;
}

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export interface UserGroup {
  id: number;
  name: string;
  description?: string;
  eventName?: string;
  memberCount: number;
  role: 'owner' | 'member';
}

class UserService {
  async updateProfile(data: UpdateProfileRequest): Promise<User> {
    const response = await api.put('/users/profile', data);
    return response.data.data;
  }

  async uploadProfilePhoto(file: File): Promise<User> {
    const formData = new FormData();
    formData.append('profilePhoto', file);

    const response = await api.post('/users/upload-photo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    
    return response.data.data;
  }

  async deleteProfilePhoto(): Promise<User> {
    const response = await api.delete('/users/profile-photo');
    return response.data.data;
  }

  async getUserById(userId: number): Promise<User> {
    const response = await api.get(`/users/${userId}`);
    return response.data.data;
  }

  async getUserProfile(): Promise<User> {
    const response = await api.get('/users/profile');
    return response.data.data;
  }

  async changePassword(data: ChangePasswordRequest): Promise<{ success: boolean }> {
    const response = await api.put('/users/change-password', data);
    return response.data.data;
  }

  async getUserGroups(userId: number): Promise<UserGroup[]> {
    const response = await api.get(`/users/${userId}/groups`);
    return response.data.data;
  }
}

export const userService = new UserService();